import { render, staticRenderFns } from "./buildSub.vue?vue&type=template&id=e2cc6272&scoped=true"
import script from "./buildSub.vue?vue&type=script&lang=js"
export * from "./buildSub.vue?vue&type=script&lang=js"
import style0 from "./buildSub.vue?vue&type=style&index=0&id=e2cc6272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cc6272",
  null
  
)

export default component.exports